import React from 'react';
import { List, Typography } from '@mui/material';
import { Repository } from '../../api/models/Repository';
import RepositoriesRow from '../RepositoriesRow/RepositoriesRow';

interface RepositoriesTableProps {
  repositories: Repository[];
  isLoading: boolean;
  onDeleteRepository: (repositoryName: string) => void;
}

const RepositoriesTable: React.FC<RepositoriesTableProps> = ({
  repositories,
  isLoading,
  onDeleteRepository,
}) => {
  if (repositories.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        No repositories found. Create your first repository to get started.
      </Typography>
    );
  }

  return (
    <List>
      {repositories.map((repository, index) => (
        <RepositoriesRow
          key={`${repository.repositoryName}-${index}`}
          repository={repository}
          index={index}
          totalRepositories={repositories.length}
          isLoading={isLoading}
          onDeleteRepository={onDeleteRepository}
        />
      ))}
    </List>
  );
};

export default RepositoriesTable;
